import BatchDataConfigApiUrls from 'src/apiUrls/BatchDataConfigApiUrls'
import BatchDataConfigFormProperties from './BatchDataConfigFormProperties'
import React from 'react'
import { components } from 'cng-web-lib'

const {
    form: { CngViewForm }
} = components

function BatchDataConfigViewForm({
    showNotification,
    id,
    onFetchPreSuccess = () => { 
        //do nothing
    }
}) {
    return (
        <CngViewForm
            fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
            showNotification={showNotification}
            bodySection={
                <BatchDataConfigFormProperties.Fields
                    disabled={true}
                    showNotification={showNotification}
                />
            }
            formikProps={BatchDataConfigFormProperties.formikProps}
            toClientDataFormat={BatchDataConfigFormProperties.toClientDataFormat}
            toServerDataFormat={BatchDataConfigFormProperties.toServerDataFormat}
            fetch={{
                id: id,
                url: BatchDataConfigApiUrls.GET,
                onPreSuccess: onFetchPreSuccess
            }}
        />
    )
}

export default BatchDataConfigViewForm
